import { shallowRef, type ShallowRef } from 'vue'

export const isCalendarFirestoreReady: ShallowRef<boolean> = shallowRef(false)

export const setCalendarFirestoreIsReady = (isReady: boolean): void => {
  isCalendarFirestoreReady.value = isReady
}
